import { render, staticRenderFns } from "./personnel.vue?vue&type=template&id=32435bf8&scoped=true"
import script from "./personnel.ts?vue&type=script&lang=ts&external"
export * from "./personnel.ts?vue&type=script&lang=ts&external"
import style0 from "./personnel.scoped.scss?vue&type=style&index=0&id=32435bf8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32435bf8",
  null
  
)

export default component.exports